var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip",class:{ show: _vm.hover },attrs:{"role":"tooltip"}},[_c('div',{staticClass:"tooltip-inner"},[_vm._t("default")],2),_c('div',{staticClass:"arrow",attrs:{"data-popper-arrow":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }